/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React, { ReactElement, memo, useMemo } from 'react';
import { Checkbox as VCheckbox } from '@veneer/core';
import { CheckboxProps } from './types';
import './styles.scss';
import { withAnalytics } from '@veneer/analytics';
import { generateID } from '../../base/helper';

const TCheckbox: React.FC<CheckboxProps> = ({
  id = generateID('clientos-ui-toolkit-checkbox'),
  isLarger,
  label,
  disabled,
  checked,
  onChange
}): ReactElement => {
  const classes = useMemo(() => {
    return [
      'clientos-ui-toolkit-checkbox',
      isLarger && 'clientos-ui-toolkit-checkbox--is-large',
      checked && 'clientos-ui-toolkit-checkbox--checked',
      disabled && 'clientos-ui-toolkit-checkbox--disabled'
    ]
      .filter(Boolean)
      .join(' ');
  }, [isLarger, checked, disabled]);

  return (
    <div
      id={id}
      className={classes}
    >
      <VCheckbox
        id={`${id}__checkbox`}
        label={
          <span
            id={`${id}__checkbox__label`}
            role="text"
            aria-label={label}
          >
            {label}
          </span>
        }
        disabled={disabled}
        checked={checked}
        onChange={onChange}
      />
    </div>
  );
};

export const CheckboxAnalytics = withAnalytics(TCheckbox);
export default memo(TCheckbox);
